<template>
  <section class="sme-container__info mg-t-30">
    <table class="table">
      <div class="th font-14">
        Information
      </div>
      <tr class="tr">
        <td>Accident Date</td>
        <td>{{ form.accident_date }}</td>
      </tr>
      <template v-if="isMotor">
        <tr class="tr">
          <td>Involved Driver</td>
          <td class="text-purple">{{ form.isrd_nm }}</td>
        </tr>
        <tr class="tr">
          <td>Involved Driver HKID</td>
          <td class="text-purple">{{ form.id_no }}</td>
        </tr>
      </template>
      <template v-else>
        <tr class="tr">
          <td>Accident Insured</td>
          <td class="text-purple">{{ form.isrd_nm }}</td>
        </tr>
      </template>
      <tr class="tr">
        <td>Brief Description Of The Accident</td>
        <td
          class="pre_wrap"
        >{{ form.description }}</td>
      </tr>
      <tr
        v-for="(item, index) in form.other_file"
        :key="index"
        class="tr">
        <td>Documents</td>
        <td
          class="blue pointer"
          @click="openFile(item.url)">{{ item.client_name }}</td>
      </tr>
      <tr
        v-if="!form.other_file"
        class="tr">
        <td>Documents</td>
        <td>-</td>
      </tr>
    </table>
    <div class="flex">
      <table class="table mg-r-10">
        <div class="th font-14">
          Contact Person
        </div>
        <tr class="tr">
          <td>Contact Person</td>
          <td>{{ form.contact_person }}</td>
        </tr>
        <tr class="tr">
          <td>Contact Number</td>
          <td>{{ form.contact_no }}</td>
        </tr>
      </table>
      <table class="table mg-l-10">
        <div class="th font-14">
          Referrer
        </div>
        <tr class="tr">
          <td>Referrer</td>
          <td>{{ referrer.isrd_nm||'-' }}</td>
        </tr>
        <tr class="tr">
          <td>Referrer Number</td>
          <td>{{  referrer.code||'-' }}</td>
        </tr>
      </table>
    </div>
    <div>
      <span class="fs-16 fw-600 block mg-b-20">Status Record</span>
      <template  v-if="record.length>0">
        <table
          v-for="(item,index) in record"
          :key="index"
          class="table">
          <div class="th font-14">
            <span class="flex  flex-sb flex-align-center">
              <span>
                <span
                  class="span-status"
                  :class="{
                    'blue': [1].includes(item.status),
                    'yellow': [0].includes(item.status),
                    'purple': [2].includes(item.status),
                    'green': [3].includes(item.status),
                    'red': [4].includes(item.status)}"
                >{{getGlobalOptionName('ticket_claim_status',item.status)}}</span>
              </span>
              <span
                v-if="item.status_updated_at"
                class="flex flex-align-center">
                <span class="color-gray60 fs-12 fw-400">last update {{item.status_updated_at||'--'}}</span>
              </span>
            </span>
          </div>
          <tr class="tr">
            <td>Remarks</td>
            <td v-html="changeLineData(item.status_remark)"></td>
          </tr>
          <tr
            v-for="(file,index) in item.status_files"
            :key="'file_'+index"
            class="tr">
            <td>
              <p>{{file.name}}</p>
              <p class="color-gray60 fs-12 fw-400">{{file.upload_date}}</p>
            </td>
            <td
              class="blue pointer"
            >
              <span
                class="blue pointer"
                @click="openFile(file.url)">{{file.client_name}}</span>
            </td>
          </tr>
        </table>
      </template>
      <template v-else>
        <span class="fs-12 color-dark fw-400">No record</span>
      </template>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'info',
  mixins: [MixinOptions],
  props:{
    form:{
      type:Object,
      default:()=>({})
    },
  },
  computed:{
    productId(){
      let {product_id} = this.form||{}
      return Number(product_id)
    },
    referrer(){
      let {referrer} = this.form||{}
      return referrer||{}
    },
    isMotor(){
      return this.productId == 11
    },
    isTravelOrPA(){
      let {type_of_insured} = this.form||{}
      return type_of_insured==2&&this.productId==18||[14].includes(this.productId)
    },
    record(){
      let {status,status_files,status_language,status_updated_at,status_remark} = this.form
      return[
        {
          status,
          status_files,
          status_language,
          status_remark,
          status_updated_at
        }
      ]
    }
  },
  mounted() {
  },
  methods:{
    openFile(url) {
      if(!url) {
        return
      }
      window.open(url, '_blank')
    },
    handleEdit(index){
      this.$emit('editClaim',index)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../quoting/sme/info";
.text-purple{
  color: #6F42C1;
}
.span-status {
  margin-right: 5px;
  padding: 2px 8px;
  border-radius: 25px;
  white-space: nowrap;
  height: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  &.blue {
    border: 1px solid #0366D6;
    color: #fff;
    background: #0366D6;
  }
  &.green {
    border: 1px solid #28A745;
    color: #fff;
    background: #28A745;
  }
  &.red{
    border: 1px solid #D73A49;
    color: #fff;
    background: #D73A49;
  }
  &.yellow{
    border: 1px solid #DBAB09;
    color: #fff;
    background: #DBAB09;
  }
}
.tr{
  .fs-12{
    font-size: 12px!important;
    line-height: 18px;
  }
}
.has-radius{
  border-radius:6px!important;
  opacity: 0.8;
}
</style>
